// extracted by mini-css-extract-plugin
module.exports = {"root":"index-root-pPcUC","textBox":"index-textBox-w4Gme"};